module.exports = __webpack_public_path__ + "static/img/mew.752acef3.png";